<template>
  <GridBase gak-global>
    <section class="top">
      <h1>
        <p>GAK<br />GLOBAL</p>
      </h1>
    </section>
    <section class="s1">
      <grid-base class="visual j">
        <h2><TextBlock file="dc/global-data-t2" class="pre-line" out-only /></h2>
      </grid-base>
      <TextBlock file="dc/global-data-t1" class="pre-line j" data-offset="100" />
    </section>
    <section class="s2">
      <h2>
        Global Region<br />
        Features
      </h2>
      <ul class="list">
        <li v-for="(item, id) in featureList" :key="id" @click="featureId = featureId === id ? null : id" :class="{ on: featureId === id }">
          <div class="item">
            <h3 v-html="item.title" />
            <h5 v-html="item.copy" />
          </div>
          <div class="over">
            <p v-html="item.exp" />
            <p>
              <span v-html="item.subExp01" ></span>
              <span v-html="item.subExp02" ></span>
            </p>
          </div>
        </li>
      </ul>
      <a href="https://www.ncloud.com" target="_blank">
        NAVER<br />
        Cloud Platform
        <Icon name="launch" />
      </a>
    </section>
    <section class="s3">
      <h2>
        Global Infra
      </h2>
      <div class="exp">
        <h4><TextBlock file="dc/global-data-t3" class="q pre-line" /></h4>
        <p class="q">
          글로벌 주요 거점을 중심으로 350여 개의 로컬 통신사들과 함께 최고의 서비스 품질과 안정적인 클라우드 서비스를 제공할 수 있는<br class="hidden-lg-up" /> 클라우드 서비스를 확대해 나가고 있습니다.
        </p>
      </div>
      <div class="wrap">
        <div class="visual" ref="map">
          <div class="map">
            <p class="area">Region America</p>
            <p class="area">Region Europe</p>
            <p class="area">Region Asia</p>
            <ul>
              <li v-for="(item, id) in world" :key="id" :class="{ off: !item.active }" @mouseover="mapId = id" @mouseout="removeBalloon">
                <a>{{ item.name }}</a>
                <p />
                <p class="balloon hidden-sm-down" :class="`b${id}`" v-html="item.balloon" v-if="id === mapId && item.balloon" />
              </li>
            </ul>
          </div>
        </div>
        <div class="info">
          <p>클라우드 서비스 제공 중</p>
          <!-- <p class="off">클라우드 서비스 제공 예정</p> -->
        </div>
        <div class="scroll__bar" ref="scrollBar">
          <div class="bar">
            <button 
              class="scroll__bar-controller"
              :style="{ left: controllerLeft + 'px' }"
              @mousedown="handleMouseStart"
              @mouseup="handleMouseUp"
              @mousemove="handleMouseMove"
              @touchstart="handleTouchStart"
              @touchend="handleTouchEnd"
              @touchmove="handleTouchMove"
              ref="controller"
            ></button>
          </div>
        </div>
        <p class="balloon hidden-md-up" v-html="mapExp" v-if="mapExp" />
        <!--      <div class="scroll q">-->
        <!--        <a class="handle"></a>-->
        <!--      </div>-->
      </div>
      <p class="balloon hidden-md-up" v-html="mapExp" v-if="mapExp" />
      <!--      <div class="scroll q">-->
      <!--        <a class="handle"></a>-->
      <!--      </div>-->
    </section>
    <section class="s4">
      <h2>
        Global Region<br />
        Details
      </h2>
      <dl class="radio">
        <template v-for="(item, id) in serviceList">
          <dt :key="`dt${id}`" :class="{ on: radioOpen === id }" @click="radioOpen = radioOpen === id ? -1 : id">
            <s v-html="item.name" />
          </dt>
          <dd :key="`dd${id}`">
            <div>
              <p v-html="item.body" />
              <span v-html="item.bodyBottom" />
              <span v-html="item.subText" class="sub"/>
            </div>
          </dd>
        </template>
      </dl>
      <ul class="items">
        <li v-for="(item, id) in serviceList" :key="id" v-html="item.name" :class="{ on: serviceId === id }" @click="serviceId = id" />
      </ul>
      <div class="exp">
        <h3 v-html="currentService.name" />
        <div>
          <p v-html="currentService.body" />
          <p v-html="currentService.bodyBottom" />
        </div>
        <p v-html="currentService.subText" class="sub"/>
      </div>
    </section>
    <article class="bottom">
      <GridBase b50>
        <TextBlock file="dc/global-data-t4" class="q pre-line" />
        <p class="q">각 춘천과 각 세종을 넘어 전 세계 주요 거점에 구축된 데이터센터를 기반으로 세계적인 수준의 기술과 서비스를 제공하며 글로벌 IT 생태계의 새로운 대안을 제시해 나갑니다.</p>
      </GridBase>
      <quick-link>
        <quick-link-item type="gray"><a class="launch" target="_blank" href="https://ncloud.com/solution/featured/globalService">NCP<br><span>글로벌 서비스<br class="hidden-md-up" />  바로가기</span></a></quick-link-item>
      </quick-link>
    </article>
    <!-- <quick-link>
      <quick-link-item
        ><router-link to="/tech/technology">NAVER <br />CLOUD PLATFORM</router-link></quick-link-item
      >
      <quick-link-item><router-link to="/archive/tech-talk">Tech Talk</router-link></quick-link-item>
    </quick-link> -->
  </GridBase>
</template>
<script>
import GridBase from '@/views/components/GridBase';
import Icon from '@/views/components/Icon';
import feature from '@/data/gak/globalFeature';
import service from '@/data/gak/globalService';
import TextBlock from '@/views/components/TextBlock';
import QuickLink from '@/views/components/QuickLink';
import QuickLinkItem from '@/views/components/QuickLinkItem';

export default {
  components: { QuickLinkItem, QuickLink, TextBlock, Icon, GridBase },
  computed: {
    featureList() {
      return feature;
    },
    mapExp() {
      if (this.mapId < 0) return false;
      return this.world[this.mapId].balloon;
    },
    serviceList() {
      return service;
    },
    currentService() {
      return service[this.serviceId];
    }
  },
  methods: {
    removeBalloon() {
      this.mapId = -1;
    },
    calculateMaxLeft() {
      const scrollBarWidth = this.$refs.scrollBar.offsetWidth;
      const controllerWidth = this.$refs.controller.offsetWidth;
      this.maxLeft = scrollBarWidth - controllerWidth;

      if (this.controllerLeft > this.maxLeft) {
        this.controllerLeft = this.maxLeft;
      }
      if (this.controllerLeft < this.minLeft) {
        this.controllerLeft = this.minLeft;
      }
    },
    handleMouseStart(e) {
      e.preventDefault();
      this.startPosX = e.clientX;
      this.startLeft = this.controllerLeft;
      this.isDragging = true;
    },
    handleMouseMove(e) {
      if (this.isDragging) {
        const deltaX = e.clientX - this.startPosX;
        let newLeft = this.startLeft + deltaX;
        if (newLeft > this.maxLeft) {
          newLeft = this.maxLeft;
        }
        if (newLeft < this.minLeft) {
          newLeft = this.minLeft;
        }
        this.controllerLeft = newLeft;  
        const mapElement = this.$refs.map;
        mapElement.scrollLeft = (newLeft / this.maxLeft) * (mapElement.scrollWidth - mapElement.clientWidth);
      }
    },
    handleMouseUp() {
      this.isDragging = false;
    },
    handleTouchStart(e) {
      e.preventDefault();
      const touch = e.touches[0];
      this.startPosX = touch.clientX;
      this.startLeft = this.controllerLeft;
      this.isDragging = true;
    },
    handleTouchMove(e) {
      if (this.isDragging) {
        const touch = e.touches[0];
        const deltaX = touch.clientX - this.startPosX;
        let newLeft = this.startLeft + deltaX;
        if (newLeft > this.maxLeft) {
          newLeft = this.maxLeft;
        }
        if (newLeft < this.minLeft) {
          newLeft = this.minLeft;
        }
        this.controllerLeft = newLeft;
        const mapElement = this.$refs.map;
        mapElement.scrollLeft = (newLeft / this.maxLeft) * (mapElement.scrollWidth - mapElement.clientWidth);
      }
    },
    handleTouchEnd() {
      this.isDragging = false;
    },
  },
  data() {
    return {
      featureId: null,
      mapId: -1,
      timerId: null,
      serviceId: 0,
      lastX: 0,
      isDown: false,
      limitX: 0,
      initX: 0,
      per: 0,
      scroll: null,
      handle: null,
      currentBalloon: null,
      radioOpen: -1,
      world: [
        { name: '미국서부', active: true, balloon: '<b>미국 서부 리전 : </b><br/>미국, 캐나다, 멕시코 등' },
        { name: '미국동부', active: false, balloon: null },
        { name: '독일', active: true, balloon: '<b>독일 리전 : </b><br/>유럽 (Euro 21개국), 아프리카, 중동 등' },
        { name: '대한민국', active: true, balloon: null },
        { name: '홍콩', active: false, balloon: '<b>홍콩 리전 : </b><br/>홍콩, 대만, 마카오, 베트남, 필리핀 등' },
        { name: '일본', active: true, balloon: '<b>일본 리전 : </b><br/>일본' },
        { name: '싱가포르', active: true, balloon: '<b>싱가포르 리전 : </b><br/>인도네시아, 말레이시아, 태국, 캄보디아, 베트남 등' },
        { name: '태국', active: false, balloon: null },
        { name: '베트남', active: false, balloon: null },
        { name: '대만', active: false, balloon: null }
      ],
      isDragging: false,
      startPosX: 0,
      startLeft: 0,
      controllerLeft: 0,
      minLeft: 0,
      maxLeft: 0 
    };
  },
  mounted() {
    window.addEventListener('touchstart', this.removeBalloon);
    this.calculateMaxLeft();
    window.addEventListener('resize', this.calculateMaxLeft);
  },
  beforeDestroy() {
    window.removeEventListener('touchstart', this.removeBalloon);
    window.removeEventListener('resize', this.calculateMaxLeft);
  }
};
</script>

<style lang="less"></style>
